module.exports = __webpack_public_path__ + "static/media/icons-ic-email-received.3d546ca5.svg";